
import { defineComponent } from 'vue'
import { useSessionModule } from '@/modules/session'
import { SessionRouteNames } from '@/router/routes-names'

export default defineComponent({
    name: 'layout-header',
    setup () {
        const { logOut, profile } = useSessionModule()

        return {
            SessionRouteNames,
            profile,
            logOut
        }
    }
})
